'use client';

import { MoreVertical, User } from 'lucide-react';
import { usePathname, useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/ui/shadcn/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/ui/shadcn/dropdown-menu';
import { cn } from '@/shared/lib/cn';
import { usePageActionsStore } from '@/shared/stores/page-actions-store';

export function PageActionsMenu() {
  const t = useTranslations('navigation');
  const tCommon = useTranslations('common');
  const menuItems = usePageActionsStore((state) => state.menuItems);
  const router = useRouter();
  const pathname = usePathname();

  const isAccountPage =
    pathname === '/account' || pathname.startsWith('/account/');

  const hasMenuItems = menuItems && menuItems.length > 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={tCommon('pageActions')}>
          <MoreVertical className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => router.push('/account')}
          className={cn(
            'flex items-center gap-2',
            isAccountPage && 'bg-accent'
          )}
        >
          <User className="h-4 w-4" />
          <span>{t('account')}</span>
        </DropdownMenuItem>

        {hasMenuItems && (
          <>
            <DropdownMenuSeparator />
            {menuItems.map((item, index) => (
              <DropdownMenuItem
                key={index}
                onClick={item.onClick}
                className={cn(
                  item.variant === 'destructive' && 'text-destructive',
                  item.disabled && 'opacity-50 cursor-not-allowed'
                )}
                disabled={item.disabled}
              >
                {item.label}
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
